import '../src/common';
import '../stylesheets/common';
import '../stylesheets/promoter_home';

var buildProgramsMap = require('../src/promoter_map/');
window.$.fn.buildProgramsMap = buildProgramsMap.default;

var buildFlipbook = require('../src/flipbook/');
window.$.fn.buildFlipbook = buildFlipbook.default;

var buildAppointmentCalendar = require('../src/appointment_calendar/');
window.$.fn.buildAppointmentCalendar = buildAppointmentCalendar.default;
